<template>
  <framed-table :striped="striped">
    <slot :rows="pageRows"/>
    <table-pager slot="footer" v-if="rows.length"
                 :total="rows.length" :page.sync="page" :page-size="pageSize"
                 @update:pageSize="changePageSize"/>
  </framed-table>
</template>

<script>
import framedTable from './framedTable.vue';
import tablePager from './tablePager.vue';
import {
  DEFAULT_PAGE_SIZE, browserStorage, pageSlice, readPageSize, writePageSize,
} from './pagination';

/**
 * `framed-table` com paginacao local. Recebe as linhas JA filtradas e
 * ordenadas e devolve so a pagina atual pelo slot:
 *
 *   <paged-table :rows="visibleRows" storage-key="feature-window-engagement-companies" v-slot="{ rows }">
 *     <thead>…</thead>
 *     <tbody><tr v-for="row in rows">…</tr></tbody>
 *   </paged-table>
 *
 * Cabecalho, ordenacao, linha expansivel e estado vazio continuam da pagina.
 * Qualquer lista nova (busca, ordenacao, recarga) volta para a primeira
 * pagina; o tamanho escolhido fica lembrado por `storageKey`.
 */
export default {
  name: 'paged-table',
  components: { framedTable, tablePager },
  props: {
    rows: { type: Array, required: true },
    storageKey: { type: String, default: '' },
    defaultPageSize: { type: Number, default: DEFAULT_PAGE_SIZE },
    striped: { type: Boolean, default: true },
  },
  data() {
    return {
      page: 1,
      pageSize: readPageSize(browserStorage(), this.storageKey, this.defaultPageSize),
    };
  },
  computed: {
    pageRows() {
      return pageSlice(this.rows, this.page, this.pageSize);
    },
  },
  watch: {
    rows() {
      this.page = 1;
    },
  },
  methods: {
    changePageSize(size) {
      this.pageSize = size;
      this.page = 1;
      writePageSize(browserStorage(), this.storageKey, size);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/vue/pages/components/default/pagedTable.vue